import { render, staticRenderFns } from "./moderator.vue?vue&type=template&id=3ef89b3c&scoped=true&"
import script from "./moderator.vue?vue&type=script&lang=js&"
export * from "./moderator.vue?vue&type=script&lang=js&"
import style0 from "./moderator.vue?vue&type=style&index=0&id=3ef89b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef89b3c",
  null
  
)

export default component.exports